export { default } from './LockSingleWriter';
